exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n.myTable[data-v-00675246] td {\n  padding: 6px 0 !important;\n}\n[data-v-00675246] .el-table__body-wrapper::-webkit-scrollbar {\n  /*滚动条整体样式*/\n  width: 6px;\n  /*高宽分别对应横竖滚动条的尺寸*/\n  height: 8px;\n}\n[data-v-00675246] .el-table__body-wrapper::-webkit-scrollbar-thumb {\n  /*滚动条里面小方块*/\n  border-radius: 2px;\n  background: #666;\n}\n[data-v-00675246] .el-table__body-wrapper::-webkit-scrollbar-track {\n  /*滚动条里面轨道*/\n  background: #ccc;\n}\n.bode_slot[data-v-00675246] {\n  background-color: pink;\n}\n", ""]);

// exports
